"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Terms = require("self-service-api/constants/Terms");

var _UIToggle = _interopRequireDefault(require("UIComponents/input/UIToggle"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var DiscountText = _styledComponents.default.span.withConfig({
  displayName: "TermSelector__DiscountText",
  componentId: "z1ibj3-0"
})(["color:", ";text-transform:uppercase;padding-left:4px;font-weight:600;"], _colors.OZ);

var StyledToggle = (0, _styledComponents.default)(_UIToggle.default).withConfig({
  displayName: "TermSelector__StyledToggle",
  componentId: "z1ibj3-1"
})(["margin:0 8px;"]);

var TermSelector = function TermSelector(_ref) {
  var activeTerm = _ref.activeTerm,
      onChange = _ref.onChange,
      trackingSource = _ref.trackingSource,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$annualDiscountPe = _ref.annualDiscountPercent,
      annualDiscountPercent = _ref$annualDiscountPe === void 0 ? 0 : _ref$annualDiscountPe,
      _ref$isGrowthSuite = _ref.isGrowthSuite,
      isGrowthSuite = _ref$isGrowthSuite === void 0 ? false : _ref$isGrowthSuite;
  var discountMessage = '';
  var shouldShowAnnualDiscountMessage = !isGrowthSuite && annualDiscountPercent;

  if (shouldShowAnnualDiscountMessage) {
    if (annualDiscountPercent === 20) {
      discountMessage = '20PercentDiscount';
    }
  }

  (0, _react.useEffect)(function () {
    (0, _getUsageTracker.default)().track('termSelectorInteraction', {
      action: 'view',
      discountShown: discountMessage,
      term: activeTerm,
      trackingSource: trackingSource
    });
  }, []);

  var onToggleChange = function onToggleChange(_ref2) {
    var checked = _ref2.target.checked;
    var term = checked ? _Terms.ANNUAL : _Terms.MONTHLY;
    onChange(term);
    (0, _getUsageTracker.default)().track('termSelectorInteraction', {
      action: 'click',
      discountShown: discountMessage,
      term: term,
      trackingSource: trackingSource
    });
  };

  return _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.billing.monthly"
  }), _react.default.createElement(_UITooltip.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.calculator.billing.disabledMessage"
    }),
    disabled: !readOnly
  }, _react.default.createElement(StyledToggle, {
    readOnly: readOnly,
    size: "extra-small",
    onChange: onToggleChange,
    checked: activeTerm === _Terms.ANNUAL,
    "data-selenium-id": "term-selector-" + trackingSource
  })), _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.billing.annual"
  }), discountMessage && _react.default.createElement(DiscountText, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.billingSelector." + discountMessage
  })));
};

var _default = TermSelector;
exports.default = _default;
module.exports = exports.default;